import React, {
  lazy,
} from 'react';
import {
  RouteObject,
} from 'react-router-dom';
import LazyLoadComponent from 'core/components/LazyLoadComponent';

const formsRoutes: RouteObject[] = [{
  path: '/forms',
  element: (
    <LazyLoadComponent Component={lazy(() => import('pages/Dashboard/pages/Forms/pages/FormWorkflow/FormWorkflowsPage'))} />
  ),
}];

export default formsRoutes;
